import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { rootRouteRef } from './routes';

export const PulsePage = PageBlueprint.make({
  params: {
    // This is the path that was previously defined in the app code.
    // It's labelled as the default one because it can be changed via configuration.
    path: '/pulse',
    // You can reuse the existing routeRef.
    routeRef: rootRouteRef,

    // these inputs usually match the props required by the component.
    loader: () => import('./pages/Pulse').then(m => <m.PulsePage />),
  },
});

export default createFrontendPlugin({
  pluginId: 'pulse',
  extensions: [PulsePage],
  featureFlags: [
    { name: 'experimental-technology-tag-based-filtering' },
    { name: 'catalog-show-users-and-groups' },
  ],
});
